const filterWidgetData = data =>
  data.widgets.map(widget => ({
    ...widget,
    masterObjectId: widget.masterObjectId || data.masterObjectId,
    masterObjectName: widget.masterObjectName || data.masterObjectName,
    masterObjectType: widget.masterObjectType || data.masterObjectType,
    masterObjectTypeId: widget.masterObjectTypeId || data.masterObjectTypeId,
    dateRangeTypeId: widget.dateRangeTypeId || data.dateRangeTypeId,
    benchmarks: widget.benchmarks.length > 0 ? widget.benchmarks : data.benchmarks,
    timeSeriesSetId: widget.timeSeriesSetId
  }));

const getDashboardData = data => ({
  isCanned: data.isCanned,
  masterObjectId: data.masterObjectId,
  masterObjectName: data.masterObjectName,
  masterObjectType: data.masterObjectType,
  masterObjectTypeId: data.masterObjectTypeId,
  dateRangeTypeId: data.dateRangeTypeId,
  objectTypeDetail: data.objectTypeDetail,
  objectTypeDetailId: data.objectTypeDetailId,
  benchmarks: data.benchmarks,
  startDate: data.startDate,
  endDate: data.endDate,
  dateRangeType: data.dateRangeType,
  description: data.description,
  name: data.name,
  layout: data.layout
});

const updateSingleWidget = (widgets, payload) => {
  const { id, data } = payload;

  return widgets.map(widget => (widget.id === id ? { ...widget, ...data } : widget));
};

export const initialState = {
  widgets: null,
  dashboardData: null
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'DASHBOARD_DATA_READY':
      return {
        widgets: filterWidgetData(action.payload),
        dashboardData: getDashboardData(action.payload)
      };

    case 'UPDATE_WIDGET':
      return {
        ...state,
        widgets: updateSingleWidget(state.widgets, action.payload)
      };
    default:
      return state;
  }
};
